import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
export const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  premium = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  return <label htmlFor={id} className={`flex items-start group cursor-pointer ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-432">
      <div className="flex items-center h-5 relative" data-id="element-433">
        <input id={id} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} className="sr-only" onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} data-id="element-434" />
        <div className={`h-5 w-5 min-w-[20px] rounded transition-all duration-200 flex items-center justify-center
            ${checked ? 'bg-[#111010] border-[#111010]' : isFocused ? 'border-[#FCCA86] bg-[#FCCA86]/10' : 'border border-gray-400 bg-white group-hover:border-[#FCCA86]'}`} data-id="element-435">
          {checked && <CheckIcon className="h-3.5 w-3.5 text-white" data-id="element-436" />}
        </div>
      </div>
      <div className="ml-2.5 text-sm" data-id="element-437">
        <span className="font-medium text-gray-800 text-[13px] leading-tight" data-id="element-438">
          {label}
        </span>
      </div>
    </label>;
};